<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Domain listesi yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="filterText" label="Domain Ara"></v-text-field>
								<v-btn icon @click="dialogNewAccount = true">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>

							<v-select v-model="filterOption" :items="getFilterOptions" item-text="text" item-value="value"
									label="Şuna göre filtrele" class="ml-3 mt-4 mr-3"></v-select>

							<v-list >
								<template v-for="(account, accountIndex) in getAccounts"> 
									<v-list-tile :key="accountIndex" avatar @click="openMe(account)" v-bind:class="{ 'account-suspended' : account.suspended,'account-unsuspended' : !account.suspended }"> 

										<v-list-tile-content>
											<v-list-tile-title> {{account.domain}}  <small class="domainUsername grey--text">{{account.user}}</small> </v-list-tile-title>  
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogNewAccount"   max-width="600px"> 
					<ServerAccountsNewAccount v-if="dialogNewAccount" :accounts="getAccounts" @closeMe="dialogNewAccountClose" />
				</v-dialog>

				<v-dialog v-model="dialogAccount"   max-width="500px"> 
					<ServerAccountsAccount v-if="dialogAccount" :account="account" @closeMe="dialogAccountClose" />
				</v-dialog>







			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	import ServerAccountsNewAccount from "@/includes/Server/Accounts/NewAccount"
	import ServerAccountsAccount from "@/includes/Server/Accounts/Account"
	export default {
		name: "ServerDomains",
		components : {
			ServerAccountsNewAccount,
			ServerAccountsAccount,
		},
		data() {
			return {
				isLoading : true,
				dialogNewAccount: false, 
				dialogAccount: false, 
				filterText : "",
				filterOption : "all",
				usedPackages : [],
				accounts : [],
				account : {}
			}
		},
		mounted(){
			this.isLoading = true; 
			this.loadAccounts();
		},
		methods : {
			loadAccounts(){
				this.$http.get( process.env.VUE_APP_API_URL + "/server/accounts/", {
					params : { }
				}).then(response => {  
					this.accounts = response.body;
					this.isLoading = false; 
				}) 
			},
			openMe(account){
				this.account = account;
				this.dialogAccount = true; 
			},
			dialogNewAccountClose(e){
				if(e){
					this.loadAccounts()
				}
				this.dialogNewAccount = false
			},
			dialogAccountClose(e){
				if(e){
					this.loadAccounts()
				}
				this.dialogAccount = false
			}
		},
		computed : {
			getFilterOptions(){
				var options = [
					{value : "all", text : "Tümü"},
					{value : "suspended", text : "Durdurulmuş"},
					{value : "unsuspended", text : "Durdurulmamış"},
				];
				for(var i in this.usedPackages){
					options.push({
						value : this.usedPackages[i],
						text : "Paket - " + this.usedPackages[i],
					})
				}
				return options;
			},
			getAccounts(){
				var accounts = [];
				var filterText = this.filterText.toLowerCase();
				var filterOption = this.filterOption;
				accounts = this.accounts.filter( function(item) {
					if(filterOption == "suspended" && item.suspended != 1){
						return false;
					}
					if(filterOption == "unsuspended" && item.suspended != 0){
						return false;
					}
					if( filterText != ""){
						if( item.domain.indexOf(filterText) < 0 && item.user.indexOf(filterText) < 0 ){
							return false;
						}
					}
					return true;
				}) 
				accounts.sort(function(a, b) {
					var nameA = a.domain.toUpperCase(); // ignore upper and lowercase
					var nameB = b.domain.toUpperCase(); // ignore upper and lowercase
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					} 
					return 0;
				});
				return accounts;
			}
		}
	}
</script>



<style lang="less">
	.account-suspended{
		color : rgb(161, 0, 0),
	}
	.account-unsuspended{
		color : rgb(0, 43, 0),
	}
	.domainUsername{
		padding-left : 15px;
		float:right;
	}
</style>
